import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { formatDoctorName } from '../utils/doctor-name.util';
import { getDoctorTitleKey } from '../utils/doctor-title.util';

@Pipe({
  name: 'doctorName',
  standalone: true,
})
export class DoctorNamePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(
    fullName?: string | null,
    title?: string | number | null,
    firstName?: string | null,
    lastName?: string | null
  ): string {
    const titleKey = getDoctorTitleKey(title);
    const resolvedTitle = titleKey
      ? this.translate.instant(titleKey)
      : (title as string | null);

    return formatDoctorName({
      fullName,
      title: resolvedTitle,
      firstName,
      lastName,
    });
  }
}
